import { render, staticRenderFns } from "./MessageCard_PROTO.vue?vue&type=template&id=5420faec&functional=true&"
import script from "./MessageCard_PROTO.vue?vue&type=script&lang=js&"
export * from "./MessageCard_PROTO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports